import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import type {
  AdminVideoCallListFilters,
  AdminVideoCallListItem,
  AdminVideoCallPaginatedResponse,
  AdminVideoCallPeriodFilters,
  AdminVideoCallPlatformStatistics,
  AdminVideoCallTeacherFilters,
  AdminVideoCallTeacherListItem,
  AdminVideoCallUsageFilters,
  AdminVideoCallUsageStatistics,
} from "~/types/admin/videoCalls";

class AdminVideoCallsModule extends HttpFactory {
  async getUsageStatistics(
    filters: AdminVideoCallUsageFilters,
  ): Promise<AdminVideoCallUsageStatistics> {
    return await this.get(
      ENDPOINTS.ADMIN.VIDEO_CALLS.USAGE_STATISTICS,
      filters,
    );
  }

  async getTeachers(
    filters: AdminVideoCallTeacherFilters,
  ): Promise<AdminVideoCallPaginatedResponse<AdminVideoCallTeacherListItem>> {
    return await this.get(ENDPOINTS.ADMIN.VIDEO_CALLS.TEACHERS, filters);
  }

  async getCalls(
    filters: AdminVideoCallListFilters,
  ): Promise<AdminVideoCallPaginatedResponse<AdminVideoCallListItem>> {
    return await this.get(ENDPOINTS.ADMIN.VIDEO_CALLS.CALLS, filters);
  }

  async getPlatformStatistics(
    filters: AdminVideoCallPeriodFilters,
  ): Promise<AdminVideoCallPlatformStatistics> {
    return await this.get(
      ENDPOINTS.ADMIN.VIDEO_CALLS.PLATFORM_STATISTICS,
      filters,
    );
  }
}

export default AdminVideoCallsModule;
